import React from 'react';
interface TestimonialCardProps {
  quote: string;
  country: string;
}
export function TestimonialCard({
  quote,
  country
}: TestimonialCardProps) {
  return <div className="bg-brand-lightBlue rounded-2xl p-6 text-left" data-id="element-233">
      <div className="flex gap-1 mb-3" data-id="element-234">
        {[1, 2, 3, 4, 5].map(i => <span key={i} className="text-yellow-400 text-lg" data-id="element-235">
            ⭐
          </span>)}
      </div>
      <p className="text-brand-navy mb-3 italic" data-id="element-236">"{quote}"</p>
      <p className="text-brand-gray font-semibold text-sm" data-id="element-237">— {country}</p>
    </div>;
}